import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  description?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
  as?: 'h2' | 'h3';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  tone = 'light',
  as: Tag = 'h2'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className={align === 'center' ? 'text-center mx-auto max-w-2xl' : 'max-w-2xl'} data-id="element-232" data-mp="3k203b9ew3c69">
      {eyebrow && <span className="inline-flex items-center gap-2 text-xs sm:text-sm font-medium tracking-[0.18em] uppercase text-brand" data-id="element-233" data-mp="gjgigryjj8lh">
          <span className="h-px w-6 bg-brand" aria-hidden="true" data-id="element-234" data-mp="1vbxfhc0mkzj" />
          {eyebrow}
        </span>}
      <Tag className={`mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1] ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-235" data-mp="6slo10b552oy">
        {title}
      </Tag>
      {description && <p className={`mt-5 text-base sm:text-lg leading-relaxed ${isDark ? 'text-white/70' : 'text-ink-soft'}`} data-id="element-236" data-mp="zc0yh8t55j7v">
          {description}
        </p>}
    </div>;
}